import { ApiError } from '@/api/client';
import { Callout } from '@/components/Callout';

/**
 * A website-analytics read that failed. Said out loud on every tab: without it an empty tab reads
 * as "no traffic yet", which is the one wrong conclusion an analytics page must never invite.
 *
 * `notFound` is the plain sentence for a 404 when the endpoint gives one meaning (the overview's
 * 404 = no source connected); otherwise the API's own message is shown.
 */
export function AnalyticsLoadError({
  error,
  what,
  notFound,
}: {
  error: unknown;
  what: string;
  notFound?: string;
}) {
  const message =
    error instanceof ApiError && error.status === 404 && notFound
      ? notFound
      : error instanceof ApiError
        ? error.message
        : 'Unexpected error — try again in a moment.';

  return (
    <Callout tone="error" title={`Could not load ${what}`}>
      {message}
    </Callout>
  );
}

/** The overview's 404 sentence, shared by every tab that reads the overview. */
export function noSourceSentence(siteKey: string): string {
  return `No analytics sources are connected for "${siteKey}". Add one on the Sources page.`;
}
